import { useState } from 'react';
import { EngageLibrarySyncActionEnum, PendingMembershipChange } from './engage-library-types';
import { EngageLibrarySaveDialog } from './EngageLibrarySaveDialog';
import styles from './EngageLibrarySaveBar.module.css';

const SAVING_LABEL = 'Saving…';
const DISCARD_LABEL = 'Discard changes';

interface EngageLibrarySaveBarProps {
  changes: PendingMembershipChange[];
  isSaving: boolean;
  isPending: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

export function EngageLibrarySaveBar({
  changes,
  isSaving,
  isPending,
  onSave,
  onDiscard,
}: EngageLibrarySaveBarProps) {
  const [showConfirm, setShowConfirm] = useState(false);

  const changeCount = changes.length;
  const hasChanges = changeCount > 0;
  const canSave = hasChanges && !isSaving && !isPending;
  const addCount = changes.filter(change => change.action === EngageLibrarySyncActionEnum.SYNC).length;
  const removeCount = changeCount - addCount;
  const countSuffix = hasChanges ? ` (${changeCount})` : '';
  const saveLabel = isSaving ? SAVING_LABEL : `Save changes${countSuffix}`;
  const changeSummary = `${addCount} to add · ${removeCount} to remove`;

  const confirmSave = () => {
    setShowConfirm(false);
    onSave();
  };

  return (
    <div className={styles.saveBar}>
      <button
        type="button"
        className={styles.saveButton}
        onClick={() => setShowConfirm(true)}
        disabled={!canSave}>
        {saveLabel}
      </button>
      {hasChanges && (
        <button type="button" className={styles.discardButton} onClick={onDiscard} disabled={isSaving}>
          {DISCARD_LABEL}
        </button>
      )}
      {hasChanges && <span className={styles.summary}>{changeSummary}</span>}
      {showConfirm && (
        <EngageLibrarySaveDialog
          changes={changes}
          onConfirm={confirmSave}
          onClose={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}
